// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../../public/siteImages/superSliderBg.png");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Peace-container-yFKxP {
	width: 100%;
	max-width: var(--max-content-width);
	margin: 0 auto;
	padding: 0 15px;
}

.Peace-easyImage-TiVfo {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-size: cover;
	background-position: 50% 50%;
	height: 100%;
	padding: 90px 0 60px;
}

.Peace-heading-CWqkA {
	font-size: 48px;
	font-weight: 600;
	margin: 0 0 38px;
	text-align: center;
}

.Peace-desc-JJJG8 {
	font-size: 18px;
	font-weight: bold;
}

/** RentAll - Begin **/

.Peace-whybnb-tyudu {
	padding-top: 15px;
	margin-bottom: 84px;
}

h4.Peace-common-NCZ8U {
	font-size: 24px;
	font-weight: 800;
	text-align: center;
	margin-bottom: 10px;
}

p.Peace-common-NCZ8U {
	font-size: 16px;
	line-height: 1.7;
	text-align: center;
	font-weight: 400;
}

.Peace-whybnb-tyudu .Peace-whyblock-B9Lmy {
	padding-right: 45px;
}

.Peace-whiteBox-Emu3y {
	background-color: var(--primary-white-bg);
	padding: 40px 36px 36px;
	-webkit-box-shadow: 0px 10px 21px #BFBFBF24;
	        box-shadow: 0px 10px 21px #BFBFBF24;
	border-radius: 6px;
}

.Peace-grayText-CD0uI {
	color: var(--muted-text-color);
}

.Peace-iconCss-tiOaF {
	width: 100%;
	max-width: 55px;
}

.Peace-gap-GADjt {
	gap: 12px;
}

.Peace-arrowCenter-Cu2pH {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	margin-top: 24px;
}

.Peace-displayInline-MaN3N {
	cursor: pointer;
}

@media screen and (max-width: 991px) {
	.Peace-whybnb-tyudu {
		padding-top: 45px;
		margin-bottom: 0px;
	}

	h4.Peace-common-NCZ8U {
		font-size: 23px;
		font-weight: 600;
	}

	.Peace-whyblock-B9Lmy {
		margin-bottom: 85px;
		padding-right: 0px !important;
		padding-left: 0px;
	}

	.Peace-mainhedding-nhFuq h1 {
		font-size: 36px;
		line-height: 51px;
		margin-bottom: 13px;
	}
}

@media screen and (max-width: 767px) {
	.Peace-whybnb-tyudu {
		margin-top: 0px;
		margin-bottom: 0px;
	}

	.Peace-common-NCZ8U {
		font-size: 23px;
		font-weight: 600;
	}

	.Peace-whyblock-B9Lmy {
		margin-bottom: 35px;
		padding-right: 0px;
		padding-left: 0px;
	}

	.Peace-mainhedding-nhFuq h1 {
		font-size: 32px;
		line-height: 51px;
		text-align: left;
		margin-bottom: 5px;
		text-align: left;
		padding-left: 15px;
		padding-right: 15px;
	}

	.Peace-steps-wja8M {
		margin-top: 24px;
	}

	h4.Peace-common-NCZ8U {
		font-size: 20px;
	}

	p.Peace-common-NCZ8U {
		font-size: 14px;
		line-height: 1.7;
		font-weight: 400;
	}
}

.Peace-hrsmall-oGdus {
	width: 51px;
	border-top: 2px solid var(--primary-border);
	display: inline-block;
	margin: 0;
}

.Peace-whyblock-B9Lmy {
	text-align: center;
}

.Peace-center-I53DC {
	text-align: center;
}

.Peace-clrbcg-fVq58 {
	background: var(--btn-primary-bg);
	color: var(--white-text);
	padding: 5%;
}

.Peace-tryButtonone-uISRW {
	height: 50px;
	line-height: 49px;
	font-size: 18px;
	padding: 0 18px;
	margin: 30px 0px;
	color: var(--common-text-color) !important;
	border-color: transparent !important;
	background-color: var(--primary-white-bg) !important;
	-webkit-box-shadow: 0px 0px 7px 0px #000000bd;
	        box-shadow: 0px 0px 7px 0px #000000bd;
	outline: none !important;
	border-radius: 60px;
	font-weight: 700;
}

.Peace-margintop20-w86YZ {
	margin-top: 20px;
}

.Peace-marginbottom20-AfyoG {
	margin-bottom: 20px !important;
}

@media (max-width: 450px) {
	.Peace-heading-CWqkA {
		font-size: 30px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/WhyHost/Peace/Peace.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,mCAAmC;CACnC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,mDAAkE;CAClE,sBAAsB;CACtB,4BAA4B;CAC5B,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA,sBAAsB;;AAEtB;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yCAAyC;CACzC,uBAAuB;CACvB,2CAAmC;SAAnC,mCAAmC;CACnC,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC;EACC,iBAAiB;EACjB,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;CAClB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,eAAe;EACf,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;AACD;;AAEA;CACC,WAAW;CACX,2CAA2C;CAC3C,qBAAqB;CACrB,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iCAAiC;CACjC,wBAAwB;CACxB,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,0CAA0C;CAC1C,oCAAoC;CACpC,oDAAoD;CACpD,6CAAqC;SAArC,qCAAqC;CACrC,wBAAwB;CACxB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC;EACC,eAAe;CAChB;AACD","sourcesContent":[".container {\n\twidth: 100%;\n\tmax-width: var(--max-content-width);\n\tmargin: 0 auto;\n\tpadding: 0 15px;\n}\n\n.easyImage {\n\tbackground: url(\"../../../../public/siteImages/superSliderBg.png\");\n\tbackground-size: cover;\n\tbackground-position: 50% 50%;\n\theight: 100%;\n\tpadding: 90px 0 60px;\n}\n\n.heading {\n\tfont-size: 48px;\n\tfont-weight: 600;\n\tmargin: 0 0 38px;\n\ttext-align: center;\n}\n\n.desc {\n\tfont-size: 18px;\n\tfont-weight: bold;\n}\n\n/** RentAll - Begin **/\n\n.whybnb {\n\tpadding-top: 15px;\n\tmargin-bottom: 84px;\n}\n\nh4.common {\n\tfont-size: 24px;\n\tfont-weight: 800;\n\ttext-align: center;\n\tmargin-bottom: 10px;\n}\n\np.common {\n\tfont-size: 16px;\n\tline-height: 1.7;\n\ttext-align: center;\n\tfont-weight: 400;\n}\n\n.whybnb .whyblock {\n\tpadding-right: 45px;\n}\n\n.whiteBox {\n\tbackground-color: var(--primary-white-bg);\n\tpadding: 40px 36px 36px;\n\tbox-shadow: 0px 10px 21px #BFBFBF24;\n\tborder-radius: 6px;\n}\n\n.grayText {\n\tcolor: var(--muted-text-color);\n}\n\n.iconCss {\n\twidth: 100%;\n\tmax-width: 55px;\n}\n\n.gap {\n\tgap: 12px;\n}\n\n.arrowCenter {\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin-top: 24px;\n}\n\n.displayInline {\n\tcursor: pointer;\n}\n\n@media screen and (max-width: 991px) {\n\t.whybnb {\n\t\tpadding-top: 45px;\n\t\tmargin-bottom: 0px;\n\t}\n\n\th4.common {\n\t\tfont-size: 23px;\n\t\tfont-weight: 600;\n\t}\n\n\t.whyblock {\n\t\tmargin-bottom: 85px;\n\t\tpadding-right: 0px !important;\n\t\tpadding-left: 0px;\n\t}\n\n\t.mainhedding h1 {\n\t\tfont-size: 36px;\n\t\tline-height: 51px;\n\t\tmargin-bottom: 13px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.whybnb {\n\t\tmargin-top: 0px;\n\t\tmargin-bottom: 0px;\n\t}\n\n\t.common {\n\t\tfont-size: 23px;\n\t\tfont-weight: 600;\n\t}\n\n\t.whyblock {\n\t\tmargin-bottom: 35px;\n\t\tpadding-right: 0px;\n\t\tpadding-left: 0px;\n\t}\n\n\t.mainhedding h1 {\n\t\tfont-size: 32px;\n\t\tline-height: 51px;\n\t\ttext-align: left;\n\t\tmargin-bottom: 5px;\n\t\ttext-align: left;\n\t\tpadding-left: 15px;\n\t\tpadding-right: 15px;\n\t}\n\n\t.steps {\n\t\tmargin-top: 24px;\n\t}\n\n\th4.common {\n\t\tfont-size: 20px;\n\t}\n\n\tp.common {\n\t\tfont-size: 14px;\n\t\tline-height: 1.7;\n\t\tfont-weight: 400;\n\t}\n}\n\n.hrsmall {\n\twidth: 51px;\n\tborder-top: 2px solid var(--primary-border);\n\tdisplay: inline-block;\n\tmargin: 0;\n}\n\n.whyblock {\n\ttext-align: center;\n}\n\n.center {\n\ttext-align: center;\n}\n\n.clrbcg {\n\tbackground: var(--btn-primary-bg);\n\tcolor: var(--white-text);\n\tpadding: 5%;\n}\n\n.tryButtonone {\n\theight: 50px;\n\tline-height: 49px;\n\tfont-size: 18px;\n\tpadding: 0 18px;\n\tmargin: 30px 0px;\n\tcolor: var(--common-text-color) !important;\n\tborder-color: transparent !important;\n\tbackground-color: var(--primary-white-bg) !important;\n\tbox-shadow: 0px 0px 7px 0px #000000bd;\n\toutline: none !important;\n\tborder-radius: 60px;\n\tfont-weight: 700;\n}\n\n.margintop20 {\n\tmargin-top: 20px;\n}\n\n.marginbottom20 {\n\tmargin-bottom: 20px !important;\n}\n\n@media (max-width: 450px) {\n\t.heading {\n\t\tfont-size: 30px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Peace-container-yFKxP`,
	"easyImage": `Peace-easyImage-TiVfo`,
	"heading": `Peace-heading-CWqkA`,
	"desc": `Peace-desc-JJJG8`,
	"whybnb": `Peace-whybnb-tyudu`,
	"common": `Peace-common-NCZ8U`,
	"whyblock": `Peace-whyblock-B9Lmy`,
	"whiteBox": `Peace-whiteBox-Emu3y`,
	"grayText": `Peace-grayText-CD0uI`,
	"iconCss": `Peace-iconCss-tiOaF`,
	"gap": `Peace-gap-GADjt`,
	"arrowCenter": `Peace-arrowCenter-Cu2pH`,
	"displayInline": `Peace-displayInline-MaN3N`,
	"mainhedding": `Peace-mainhedding-nhFuq`,
	"steps": `Peace-steps-wja8M`,
	"hrsmall": `Peace-hrsmall-oGdus`,
	"center": `Peace-center-I53DC`,
	"clrbcg": `Peace-clrbcg-fVq58`,
	"tryButtonone": `Peace-tryButtonone-uISRW`,
	"margintop20": `Peace-margintop20-w86YZ`,
	"marginbottom20": `Peace-marginbottom20-AfyoG`
};
module.exports = ___CSS_LOADER_EXPORT___;
